<template>
	<b-modal
		:hide-footer="true"
		:title="$t('Cadastrar Biometria')"
		centered
		size="xl"
		id="create-biometria"
	>
		<div class="row d-flex justify-content-between">
			<form-select
				grid="6"
				label="Mão esquerda"
				v-model="dedos_esquerdo"
				:itens="mao_esquerda"
				@change="selectedDedo(dedos_esquerdo)"
			/>
			<form-select
				grid="6"
				label="Mão Direita"
				v-model="dedos_direito"
				:itens="mao_direita"
				@change="selectedDedo(dedos_direito)"
			/>
		</div>
		<div class="row d-flex justify-content-end">
			<button class="btn btn-danger btn-sm mt-0">
				Invalidar dedo <i class="mdi mdi-close"></i>
			</button>
			<button @click="submit" class="btn btn-success btn-sm btn-submit mt-0 mr-3">
				Ler Biometria
			</button>
		</div>
		<div class="row">
			<div class="col-md-9">
				<div class="row rounded border ml-0 bg-light">
					<div class="dedo" v-for="item in 5" :id="`dedo_e_${item}`" :key="item"></div>
					<div class="dedo" v-for="item in 5" :id="`dedo_d_${item}`" :key="item"></div>
					<!-- <div class="dedo" id="dedo_e_2"></div>
					<div class="dedo" id="dedo_e_3"></div>
					<div class="dedo" id="dedo_e_4"></div>
					<div class="dedo" id="dedo_e_5"></div> -->
					<img :src="maos_biometria" class="w-100" />
				</div>
			</div>
			<div class="col-md-3">
				<div class="col-12 bg-gray mb-3">
					<img :src="dedo__biometria" class="w-100" />
				</div>
				<h5>Qualidade:</h5>
				<h3>{{ qualidade }}</h3>
				<h5>Resultado da leitura:</h5>
				<h3>{{ result }}</h3>
			</div>
		</div>
		<div class="row pt-4 px-2 d-flex justify-content-end"></div>
	</b-modal>
</template>
<script>
export default {
	data() {
		return {
			qualidade: "",
			result: "",
			mao_direita: [
				{ id: "dedo_d_1", value: "Mínimo Direito" },
				{ id: "dedo_d_2", value: "Anelar Direito" },
				{ id: "dedo_d_3", value: "Médio Direito" },
				{ id: "dedo_d_4", value: "Indicador Direito" },
				{ id: "dedo_d_5", value: "Polegar Direito" },
			],
			mao_esquerda: [
				{ id: "dedo_e_1", value: "Mínimo Esquerdo" },
				{ id: "dedo_e_2", value: "Anelar Esquerdo" },
				{ id: "dedo_e_3", value: "Médio Esquerdo" },
				{ id: "dedo_e_4", value: "Indicador Esquerdo" },
				{ id: "dedo_e_5", value: "Polegar Esquerdo" },
			],
			dedos_direito: [],
			dedos_esquerdo: [],
			dedo__biometria: "/img/biometria.png",
			maos_biometria: "/img/maos_biometria.png",
		};
	},
	methods: {
		submit() {},
		selectedDedo(id) {
			const dedo = document.getElementById(id).classList.add("dedo_selected");
		},
	},
};
</script>
<style lang="css">
.dedo {
	z-index: 9;
	position: absolute;
	background: #e1e1e1;
	border: 2px solid gray;
	border-radius: 50%;
	height: 30px;
	width: 30px;
}
.dedo_selected {
	background: #e1e1e1 !important;
	border: 2px solid rgb(0, 132, 255) !important;
	content: "\f00c";
}
.dedo_success {
	background: #beedc9 !important;
	border: 2px solid rgb(22 86 37) !important;
	content: "\f00c";
}
.dedo_error {
	background: #af4949 !important;
	border: 2px solid rgb(87, 15, 15) !important;
	content: "\f00d";
}
#dedo_e_1 {
	left: 10.5%;
	top: 20%;
}
#dedo_e_2 {
	left: 16.5%;
	top: 10%;
}
#dedo_e_3 {
	left: 23%;
	top: 9%;
}
#dedo_e_4 {
	left: 30.5%;
	top: 11%;
}
#dedo_e_5 {
	left: 40%;
	top: 43%;
}
#dedo_d_1 {
	right: 8.5%;
	top: 20%;
}
#dedo_d_2 {
	right: 14.5%;
	top: 10%;
}
#dedo_d_3 {
	right: 21%;
	top: 8.5%;
}
#dedo_d_4 {
	right: 29%;
	top: 11%;
}
#dedo_d_5 {
	right: 38%;
	top: 43%;
}
</style>
